import React from 'react';
import { InputErrorIcon, InputErrorIconTooltip } from './styles';
const InputErrorTooltip = (error) => {
    return (React.createElement(InputErrorIcon, null,
        React.createElement(InputErrorIconTooltip, null,
            React.createElement("span", null, error.message),
            React.createElement("div", { className: "shadow" }))));
};
export default InputErrorTooltip;
